export default function getPosition (node, scope) {
    const root = scope || document;
    const width = node.clientWidth
    const height = node.clientHeight
    let offsetTop  = node.offsetTop;
    let offsetLeft = node.offsetLeft;
    while (node && node.offsetParent && node.offsetParent != document && node !== root && root !== node.offsetParent ) {
        offsetTop += node.offsetParent.offsetTop;
        offsetLeft += node.offsetParent.offsetLeft;
        node = node.offsetParent;
    }
    return {
        top: offsetTop,
        left: offsetLeft,
        width, 
        height
    };
}